"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateTaxFields = StateTaxFields;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _Button = _interopRequireDefault(require("../../Button"));

var _CheckboxField = _interopRequireDefault(require("../CheckboxField"));

var _set = _interopRequireDefault(require("lodash/set"));

var _get = _interopRequireDefault(require("lodash/get"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var keyTranslations = {
  Lease: 'Lease',
  TaxCashEquityCapCostReduction: 'Tax Cash Equity Cap Cost Reduction',
  RegistrationFee: 'Registration Fee',
  SalesUseTaxPct: 'Sales Use Tax Percent',
  CapCostReductionTaxPct: 'Cap Cost Reduction Tax Percent',
  ExemptNegativeEquityFromTax: 'Exempt Negative Equity From Tax',
  IsSellingPriceBased: 'Is Selling Price Based',
  SalesTaxInCap: 'Sales Tax In Cap',
  TaxBankFees: 'Tax Bank Fees',
  TaxCappedInterestOnSalesTax: 'Tax Capped Interest On Sales Tax',
  UseTaxPct: 'Use Tax Percent',
  SalesUseTaxPctAdjustment: 'Sales Use Tax Percent Adjustment',
  Retail: 'Retail',
  NewOrleansParish: 'New Orleans Parish',
  ApplyTradeInCreditAllowance: 'Apply Trade In Credit Allowance',
  ApplyCAFTaxExemption: 'Apply CAF Tax Exemption',
  TaxBankFee: 'Tax Bank Fee',
  WarrantyTaxPct: 'Warranty Tax Percent',
  RTATaxApply: 'RTA Tax Apply',
  RTATaxPct: 'RTA Tax Percent',
  TaxBankFeesInInceptionFees: 'Tax Bank Fees In Inception Fees',
  TaxFullRebateAmount: 'Tax Full Rebate Amount',
  TaxOnBankFeeInCap: 'Tax On Bank Fee In Cap',
  CalculateRegistrationFee: 'Calculate Registration Fee',
  CollectLienFeesFromLender: 'Collect Lien Fees From Lender',
  SurchargeOnCappedDownpaymentTax: 'Surcharge On Capped Downpayment Tax',
  RegisterAsPassengerVehicle: 'Register As Passenger Vehicle',
  HasAffidavit: 'Has Affidavit',
  TaxCCRebate: 'Tax CC Rebate',
  MinimumTaxCharge: 'Minimum Tax Charge',
  CityTaxPct: 'City Tax Percent',
  MarketIsColoradoSprings: 'Market Is Colorado Springs',
  CountyTaxInPayment: 'County Tax In Payment',
  RTDTaxInPaymentPct: 'RTD Tax In Payment Percent',
  DontChargeCityTax: 'Dont Charge City Tax',
  StateTaxInPaymentPct: 'State Tax In Payment Percent',
  CountyTaxPct: 'County Tax Percent',
  CityTaxInPayment: 'City Tax In Payment',
  DMVFeeAdjustment: 'DMV Fee Adjustment',
  UsedVehicleDMVTransferFee: 'Used Vehicle DMV Transfer Fee',
  UsedVehicleTransferCurrentRegistration: 'Used Vehicle Transfer Current Registration',
  WaiveRegistrationFee: 'Waive Registration Fee',
  ApplySupplementalTitleFee: 'Apply Supplemental Title Fee',
  CollectWasteTireFeeOnUsedVehicle: 'Collect Waste Tire Fee On Used Vehicle',
  DontApplySupplementalTitleFee: 'Dont Apply Supplemental Title Fee',
  DownPaymentIncludedInSalesTax: 'Down Payment Included In Sales Tax',
  IncludeAcquisitionFeeIntoSupplementalTitleFeeCalc: 'Include Acquisition Fee Into Supplemental Title Fee Calculation',
  SupplementalTitleFeeInCap: 'Supplemental Title Fee In Cap',
  SuppTitleFeeBasedOnAdjSellingPrice: 'Supplemental Title Fee Based On Adjusted Selling Price',
  EnrolledOReGO: 'Enrolled OReGO',
  // ??
  PFSPropertyTaxInPayment: 'PFS Property Tax In Payment',
  StateFees: 'State Fees',
  RegisterElectronically: 'Register Electronically',
  LendersAndMembersFeePct: 'Lenders And Members Fee Percent',
  NoInventoryTaxOnNewVehicle: 'No Inventory Tax On New Vehicle',
  TaxCost: 'Tax Cost',
  // v curious what this one does
  VehicleInventoryTaxPct: 'Vehicle Inventory Tax Percent',
  TaxExemptACV: 'Tax Exempt ACV',
  RegisterAsCommercialAndPassengerVehicle: 'Register As Commercial And Passenger Vehicle',
  CollectGaragedStateSalesTax: 'Collect Garaged State Sales Tax',
  MillRate: 'Mill Rate',
  DontAutoApplyExtraTax: 'Dont AutoApply Extra Tax',
  LocalBusinessTaxPct: 'Local Business Tax Percent',
  AftermarketAddOns: 'Aftermarket Add-Ons',
  StateBusinessTaxPct: 'State Business Tax Percent',
  StateAftermarketTaxPct: 'State Aftermarket Tax Percent',
  LocalSalesTaxPct: 'Local Sales Tax Percent',
  LocalBusinessAftermarketTaxPct: 'Local Business Aftermarket Tax Percent',
  LocalBusinessAftermarketTaxUpfront: 'Local Business Aftermarket Tax Upfront',
  LocalBusinessTaxUpfront: 'Local Business Tax Upfront',
  LocalSalesTaxUpfront: 'Local Sales Tax Upfront',
  SalesUseTaxUpfront: 'Sales Use Tax Upfront',
  StateBusinessTaxUpfront: 'State Business Tax Upfront',
  StateSingleArticleTaxUpfront: 'State Single Article Tax Upfront',
  StateSingleArticleTaxPct: 'State Single Article Tax Percent',
  LocalAftermarketTaxPct: 'Local Aftermarket Tax Percent',
  TaxGapInsurance: 'Tax Gap Insurance',
  MotorVehicleLeaseTaxPct: 'Motor Vehicle Lease Tax Percent',
  StateDocFeeInCap: 'State Doc Fee InC ap',
  StateDocFeePct: 'State Doc Fee Percent'
};
var BLACKLIST = ['RegistrationFee', 'CalculateRegistrationFee'];

function StateTaxFields(props) {
  var _props$path = props.path,
      path = _props$path === void 0 ? [] : _props$path,
      _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      onChange = props.onChange,
      values = props.values,
      _props$fieldSize = props.fieldSize,
      fieldSize = _props$fieldSize === void 0 ? 'small' : _props$fieldSize,
      className = props.className,
      isChild = props.isChild,
      _props$header = props.header,
      header = _props$header === void 0 ? null : _props$header;

  var handleInputLocal = function handleInputLocal(key) {
    var isValueField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function (e) {
      var newPath = path.concat([key]);
      var valueToSend = isValueField ? e.target.value : !Boolean((0, _get.default)(values, newPath.join('.')));
      return onChange(newPath, valueToSend);
    };
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('state-fee-tax-fields', className, {
      'is-child': isChild
    })
  }, header && /*#__PURE__*/_react.default.createElement("h4", null, header), [].concat(_toConsumableArray((0, _sortBy.default)(Object.keys(fields).filter(function (k) {
    return fields[k].kind !== 'object';
  }), function (k) {
    return fields[k].kind;
  }).reverse()), _toConsumableArray(Object.keys(fields).filter(function (k) {
    return fields[k].kind === 'object';
  }))).map(function (key) {
    // short circuit and skip registration fee fields
    if (BLACKLIST.includes(key)) {
      return null;
    }

    var fieldProps = fields[key],
        currentValue = (0, _get.default)(values, path.concat([key]).join('.')),
        label = keyTranslations[key];

    if (fieldProps.kind === 'object') {
      return /*#__PURE__*/_react.default.createElement(StateTaxFields, {
        values: values,
        key: key,
        className: key,
        isChild: true,
        header: key,
        onChange: onChange,
        path: path.concat([key]),
        fieldSize: fieldSize,
        fields: fieldProps.oneOf.filter(function (x) {
          return x.type === 'object';
        })[0].properties
      });
    } else if (fieldProps.kind === 'boolean') {
      return /*#__PURE__*/_react.default.createElement(_CheckboxField.default, {
        key: key,
        checked: Boolean(currentValue),
        onChange: handleInputLocal(key, false),
        label: label
      });
    } else {
      // TODO handle validations
      return /*#__PURE__*/_react.default.createElement(_TextField.default, {
        key: key,
        value: (currentValue || '').toString(),
        onChange: handleInputLocal(key),
        validateFor: "decimal",
        label: label,
        size: fieldSize
      });
    }
  }));
} //////////////////////////////////////////////////
// deprecated //
//////////////////////////////////////////////////


var StateFeeTaxAutoForm = /*#__PURE__*/function (_React$Component) {
  _inherits(StateFeeTaxAutoForm, _React$Component);

  var _super = _createSuper(StateFeeTaxAutoForm);

  function StateFeeTaxAutoForm(props) {
    var _this;

    _classCallCheck(this, StateFeeTaxAutoForm);

    _this = _super.call(this, props);
    _this.state = {
      formValues: props.formValues
    };
    _this.inputChangeFn = _this.inputChangeFn.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StateFeeTaxAutoForm, [{
    key: "inputChangeFn",
    value: function inputChangeFn(path, value) {
      var formValues = this.state.formValues,
          currentState = Object.assign(formValues);
      (0, _set.default)(currentState, path.join('.'), value);
      this.setState({
        formValues: currentState
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var formValues = this.props.formValues,
          properties = this.props.stateConfig.properties;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "state-fee-tax-form"
      }, formValues && /*#__PURE__*/_react.default.createElement(StateTaxFields, {
        values: formValues,
        path: [],
        onChange: this.inputChangeFn,
        fields: properties,
        fieldSize: this.props.fieldSize
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: function onClick() {
          _this2.props.onSubmit(formValues);
        }
      }, "Apply"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        text: true,
        onClick: this.props.onCancel
      }, "Cancel"));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(newProps, oldState) {
      return _objectSpread(_objectSpread({}, oldState), newProps);
    }
  }]);

  return StateFeeTaxAutoForm;
}(_react.default.Component);

var _default = StateFeeTaxAutoForm; // TODO: Why doesnt the state hook play nice here?
//
// export default function StateFeeTaxAutoForm({stateConfig, values={}, onSubmit}){
//   const {title, properties} = stateConfig,
//   [formState, setFormState] = useState(values),
//   inputChangeFn = (path,value) => {
//     let currentState = Object.assign(formState);
//     console.log(formState)
//     set(currentState, path.join('.'), value)
//     setFormState(currentState);
//   }
//
//
//
//   return(
//     <div>
//       <h1>{title}</h1>
//       <StateTaxFields values={formState} path={[]} onChange={inputChangeFn} fields={properties} />
//       <Button onClick={()=>{onSubmit(formState)}}>Update Config</Button>
//     </div>
//   )
// }

exports.default = _default;